import { zergApi } from "@/service/zerg";


class UserServices {

    async register(payload) {
        try {
            const data = await zergApi.post('/user/register', payload);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async updateUser(params) {
        try {
            const data = await zergApi.post('/user/update-user', params);
        } catch (error) {
            throw error;
        }
    }

    async getRoles() {
        try {
            const data = await zergApi.get('/role/list')
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getCampus() {
        try {
            const data = await zergApi.get('/campus/list')
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getUsers(payload) {
        try {
            const data = await zergApi.post('/user/list', payload);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getModules() {
        try {
            const data = await zergApi.get('/module/list');
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getPersonals() {
        try {
            const data = await zergApi.get('/rrhh/employee/list-select');
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getUserEdit(params) {
        try {
            const data = await zergApi.post("/user/get-user-edit", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getUserProfile(params) {
        try {
            const data = await zergApi.post("/user/get-profile-user", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async downloadQr(params) {
        try {
            const data = await zergApi.post("/user/download-qr", params, { responseType: 'blob' });
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getUserQr(params) {
        try {
            const data = await zergApi.post("/user/get-user-qr", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getDriverInformation(params) {
        try {
            const data = await zergApi.post("/driver/get-information-driver", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async updateProfile(params) {
        try {
            const data = await zergApi.post("/user/update-profile-user", params);
            return data;
        } catch (error) {
            throw error;
        }
    }
}

export default new UserServices();